import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Col,
  Divider,
  Modal,
  Popover,
  Row,
  Select,
  Space,
  List,
  Skeleton,
  Checkbox,
  Typography,
} from "antd";
import "./style.css";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../../../firebase";
import { toast } from "react-hot-toast";
import MoveOutContent from "./MoveOutContent";
import MakeReadyContent from "./MakeReadyContent";
import SDRefundContent from "./SDRefundContent";
import PropertyListing from "./PropertyListing";
import ListingFollowUp from "./ListingFollowUp";
import MoveIn from "./MoveIn";
import WorkOrderFollowUp from "./WorkOrderFollowUp";
import LeaseRenewal from "./LeaseRenewal";
import PayOrQuit from "./PayOrQuit";

const { Text } = Typography;
const ModalContent = ({
  modalId,
  isModalOpen,
  setIsModalOpen,
  workItemList,
  id,
}) => {

  const [filterData, setFilterData] = useState(null);
  const [itemFilterData, setItemFilterData] = useState(null);
  const [visible, setVisible] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [listId, setListId] = useState(null);
  const [checkedItems, setCheckedItems] = useState({}); // State for keeping track of checked items

  useEffect(() => {
    const initialCheckedItems = {};

    workItemList?.workItemList.forEach((item) => {
      initialCheckedItems[item.id] = item.status === "completed";
    });

    setCheckedItems(initialCheckedItems);
  }, [workItemList]);

  const handleCompleteStatus = () => {
    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const assignedCollectionRef = collection(itemListRef, "Assigned");
    const docToUpdateRef = doc(assignedCollectionRef, id); // Replace "docId" with your specific document ID
    // Update the document
    async function updateDocument() {
      try {
        await updateDoc(docToUpdateRef, {
          // replace with the fields you want to update
          status: "completed",
        });
        toast.success("successfully updated!");
        setIsModalOpen(false);
      } catch (error) {
        console.error("Error updating document:", error);
        toast.error("Error updating document!", error.message);
      }
    }
    updateDocument();
  };

  const fetchItemList = async () => {
    try {
      const tasksRef = collection(db, "tasks");
      const itemListRef = doc(tasksRef, "itemList");
      const listData = collection(itemListRef, "items");

      const querySnapshot = await getDocs(listData);
      const allItems = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        data.docId = doc.id; // Here we're adding the document ID to the item data
        return data;
      });

      const filterByTitle = (data, name) => {
        return data.filter((item) =>
          item.title.toLowerCase().includes(name.toLowerCase())
        );
      };

      const filteredData = filterByTitle(allItems, modalId);
      setFilterData(filteredData[0]);
    } catch (error) {
      console.log("error", error.message);
    }
  };

  useEffect(() => {
    fetchItemList();
  }, [modalId]);

  const handleOnClick = (id, listId) => {
    setItemId(id);
    setListId(listId);
    console.log("test id:-", id);
    const itemfilter = filterData.itemList.find((item) => item.id === id);

    console.log("itemfilter::", itemfilter);
    setItemFilterData(itemfilter);
  };

  const runModal = (
    <div>
      <Row gutter={16} justify="center">
        <Col>ASSIGN USERS</Col>
      </Row>
      <Divider style={{ margin: "5px 0" }} />
      <Row gutter={16}>
        <Col>
          <Select
            style={{ width: "100%" }}
            showSearch
            allowClear
            placeholder="e.g. batman@batman.com"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={[
              {
                value: "1",
                label: "Not Identified",
              },
            ]}
          />
          <p style={{ maxWidth: "200px", marginTop: "10px" }}>
            Search for a person in your organization by name or email address,
            or enter an email address to invite a guest.
          </p>
        </Col>
      </Row>
    </div>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setItemId(null);
  };

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");
  const updateAssignedWorkItemListStatus = async (targetDocId, idStatusMap) => {
    const targetDocRef = doc(assignedCollectionRef, targetDocId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status: idStatusMap[item.id.toString()]
                ? "completed"
                : "incompleted",
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  useEffect(() => {
    const length = Object.keys(checkedItems).length;
    if (length) {
      updateAssignedWorkItemListStatus(id, checkedItems);
    }
  }, [checkedItems]);

  const handleCheckBoxClick = (e, index, id) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    // Update the checked state of this item
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [id]: !prevCheckedItems[id],
    }));
  };

  const handleBackBtn = () => {
    setItemId(null);
  };

  const getInitials = (name) => {
    return name ? name.substring(0, 2) : "";
  };

  return (
    <div className="ModalContent">
      <Modal
        className="modal-content"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        title={
          <div className="title">
            {itemId && (
              <span onClick={handleBackBtn} style={{ cursor: "pointer" }}>
                {" "}
                <i
                  className="fa-solid fa-arrow-left"
                  style={{ fontSize: "20px" }}
                ></i>{" "}
                |{" "}
              </span>
            )}
            <span>{filterData?.emoji}</span>
            {itemId ? (
              <div>
                <h2>{itemFilterData?.title}</h2>
                <p>
                  {filterData?.title} {workItemList?.workFlowRunDueTime}{" "}
                  workflow run | {filterData?.title}
                </p>
              </div>
            ) : (
              <div>
                <h2>
                  {filterData?.title} {filterData?.timing} workflow run
                </h2>
                <p>{filterData?.title}</p>
              </div>
            )}
          </div>
        }
      >
        <Divider style={{ margin: "5px 0" }} />
        <Row justify="space-between">
          <Col>
            {itemId ? (
              <i className="fa-regular fa-clock"></i>
            ) : (
              <>
                <Row gutter={16}>
                  <Col>
                    <Popover
                      content={runModal}
                      trigger="click"
                      visible={visible}
                      onVisibleChange={handleVisibleChange}
                      placement="bottom"
                    >
                      <Button type="text" onClick={(e) => e.preventDefault()}>
                        <Space>
                          <i className="fa-regular fa-user"></i>
                          Assign
                        </Space>
                      </Button>
                    </Popover>
                  </Col>
                  <Col>
                    {workItemList?.workFlowRunAssignee?.map((name, index) => (
                      <Avatar key={index}>{getInitials(name)}</Avatar>
                    ))}
                  </Col>
                  <Col>
                    <Button type="text" onClick={(e) => e.preventDefault()}>
                      <Space>
                        <i className="fa-regular fa-clock"></i>
                        {workItemList?.workFlowRunDueDate} at{" "}
                        {workItemList?.workFlowRunDueTime}
                      </Space>
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Col>
          {!itemId && (
            <Col>
              <Button type="text" onClick={handleCompleteStatus}>
                <i
                  className="fa-solid fa-square-check"
                  style={{ fontSize: "26px" }}
                ></i>
              </Button>
            </Col>
          )}
        </Row>

        {filterData?.title.includes("Move Out") && (
          <MoveOutContent
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Make Ready") && (
          <MakeReadyContent
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("SD Refund") && (
          <SDRefundContent
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Property Listing") && (
          <PropertyListing
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Listing Follow up") && (
          <ListingFollowUp
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Move In") && (
          <MoveIn itemId={itemId} listId={listId} checkedItems={checkedItems} />
        )}

        {filterData?.title.includes("Work Order Follow up") && (
          <WorkOrderFollowUp
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Lease Renewal") && (
          <LeaseRenewal
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {filterData?.title.includes("Pay / Quit") && (
          <PayOrQuit
            itemId={itemId}
            listId={listId}
            checkedItems={checkedItems}
          />
        )}

        {!itemId && (
          <List
            className="list-container"
            itemLayout="horizontal"
            bordered
            dataSource={workItemList?.workItemList}
            renderItem={(item, index) => (
              <List.Item
                className="list-item"
                onClick={() => handleOnClick(index + 1, workItemList?.docId)}
                style={{ cursor: "pointer" }}
              >
                <Skeleton avatar title={false} loading={item.loading} active>
                  <List.Item.Meta
                    avatar={
                      <div className="item-container">
                        <span style={{ marginRight: "10px" }}>
                          {index + 1}.{" "}
                        </span>

                        {item.checkBox && (
                          <Checkbox
                            onClick={(e) =>
                              handleCheckBoxClick(e, index, item.id)
                            }
                            style={{ marginRight: "10px" }}
                            checked={checkedItems[item.id]}
                          ></Checkbox>
                        )}
                        <Text
                          strong={!item.checkBox && true}
                          delete={checkedItems[item.id]} // Apply strikethrough if the item id in checkedItems is true
                        >
                          {item.title}
                        </Text>
                      </div>
                    }
                  />
                </Skeleton>
              </List.Item>
            )}
          />
        )}
      </Modal>
    </div>
  );
};

export default ModalContent;
